module.exports = __webpack_public_path__ + "img/Js.b849f284.png";